var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconopenText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-text",
    "data-name": "Icon open-text",
    d: "M0,0V2.5H.625a1.254,1.254,0,0,1,1.25-1.25H3.75V8.125a.619.619,0,0,1-.625.625H2.5V10h5V8.75H6.875a.619.619,0,0,1-.625-.625V1.25H8.125A1.254,1.254,0,0,1,9.375,2.5H10V0Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconopenText);
export default __webpack_public_path__ + "static/media/Icon open-text.378137ea89e4de80699da84114640d36.svg";
export { ForwardRef as ReactComponent };